import React from 'react';
import PropTypes, {
  func,
  shape,
  string,
} from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import './AmexGDAReferFriend.scss';
import CustomImage from '../CustomImage';
import { ACQUISITION_CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';

const AmexGDAReferFriend = (props) => {
  const {
    baseRequestUrl,
    pageContentByLanguage: {
      referFriendImgDesktop,
      referFriendImgTablet,
      referFriendImgMobile,
      referFriendImgLogo,
      referFriendImgLogoAlt,
      referFriendCTA,
      referFriendCTALink,
      referFriendHeading,
      referFriendText,
      referFriendFinePrint,
    },
    printContent,
    Analytics,
  } = props;
  const imageBackgroundDesktop = `url(${baseRequestUrl}GDA/images/${referFriendImgDesktop})`;

  const onClickLink = () => {
    handleMktAnalytics(Analytics.event, ACQUISITION_CTA_EVENT_NAME, {
      action_name: 'MGM - Click',
    });
  };
  return (
    <div className="GDA__section--refer" id="referFriend">
      <div className="GDA__Refer">
        <div
          className="GDA__Refer__image desktop"
          style={{ backgroundImage: imageBackgroundDesktop }}
        />
        <div className="GDA__Refer__image tablet">
          <CustomImage
            imageName={referFriendImgTablet}
            alt=""
            baseRequestUrl={baseRequestUrl}
          />
        </div>
        <div className="GDA__Refer__image mobile">
          <CustomImage
            imageName={referFriendImgMobile}
            alt=""
            baseRequestUrl={baseRequestUrl}
          />
        </div>
        <div className="GDA__Refer__content">
          <h2>{printContent(referFriendHeading, 'referFriendHeading')}</h2>
          <CustomImage
            imageName={referFriendImgLogo}
            alt={referFriendImgLogoAlt}
            baseRequestUrl={baseRequestUrl}
            className="GDA__Refer__content-logo"
          />
          <p>{printContent(referFriendText, 'referFriendText')}</p>
          <p>
            <Link
              href={referFriendCTALink}
              className="GDA__Refer--CTA"
              onContextMenu={onClickLink}
              onClick={onClickLink}
            >
              {printContent(referFriendCTA, 'referFriendCTA')}
            </Link>
          </p>
          <p className="GDA__Refer__content-fine-print">
            {printContent(referFriendFinePrint, 'referFriendFinePrint')}
          </p>
        </div>
      </div>
    </div>
  );
};

AmexGDAReferFriend.propTypes = {
  baseRequestUrl: string.isRequired,
  pageContentByLanguage: shape({
    referFriendImgDesktop: string,
    referFriendImgMobile: string,
    referFriendImgLogo: string,
    referFriendImgLogoAlt: string,
    referFriendCTA: string,
    referFriendCTALink: string,
    referFriendHeading: string,
    referFriendText: string,
    referFriendFinePrint: string,
  }).isRequired,
  printContent: func.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
};

export default AmexGDAReferFriend;
